import { axios } from "../../../../lib/axios";

export const searchEncounters = ({
    orgId,
    start,
    end,
    type,
    status,
    encounterId,
    patientId,
    practitionerId,
    page,
    pageSize,
    getAll = false,
    activePractitioner,
}) => {
    let url = `encounter/search?orgId=${orgId}`;
    url += start ? `&DateStart=${start}` : "";
    url += end ? `&DateEnd=${end}` : "";
    url += type ? `&type=${type}` : "";
    url += encounterId ? `&encounterId=${encounterId}` : "";
    url += patientId ? `&patientID=${encodeURIComponent(patientId)}` : "";
    url += status ? `&status=${status}` : "";
    url += practitionerId ? `&practitionerID=${practitionerId}` : "";
    url += page ? `&page=${page}` : "";
    url += pageSize ? `&pageSize=${pageSize}` : "";
    url += getAll ? `&getAll=${getAll}` : "";
    url += activePractitioner ? `&activePractitioner=${activePractitioner}` : "";
    return axios.get(url);
};

export const createEncounterInbound = ({
    patient,
    status,
    practitionerId,
    practitionerName,
    proceedWith,
    orgId,
    orgName,
    intakeQuestions,
    requestedPeriod,
    statusHistory,
    patientLocation,
    serviceLineId,
    serviceLine,
}) => {
    const payload = {
        subject: patient,
        managingOrganization: {
            reference: `Organization/${orgId}`,
            type: "Organization",
            display: orgName || "",
        },
        serviceProvider: {
            display: orgName,
            type: "Organization",
            reference: `Organization/${orgId}`,
        },
        practitionerId,
        participant: [
            {
                individual: {
                    reference: `Practitioner/${practitionerId}`,
                    type: "Practitioner",
                    display: practitionerName,
                },
            },
        ],
        period: requestedPeriod,
        patientLocation: patientLocation || intakeQuestions?.location,
        proceedWith,
        status,
        statusHistory,
    };
    if (intakeQuestions) payload.intakeQuestions = intakeQuestions;

    if (serviceLineId) payload.serviceLineId = serviceLineId;
    if (serviceLine) payload.serviceLine = serviceLine;

    return axios.post("encounter", payload);
};

export const editEncounter = ({
    encounterId,
    status,
    encounterClass,
    patient,
    practitionerId,
    practitionerName,
    proceedWith,
    orgId,
    orgName,
    intakeQuestions,
    requestedPeriod,
    patientLocation,
    statusHistory,
    actor,
    participant,
    serviceLineId,
    serviceLine,
}) => {
    const defaultParticipant = [
        {
            individual: {
                reference: `Practitioner/${practitionerId}`,
                type: "Practitioner",
                display: practitionerName,
            },
        },
    ];
    const payload = {
        participant: participant || defaultParticipant,
    };

    if (patient) payload.subject = patient;
    if (orgId && orgName) {
        payload.serviceProvider = {
            reference: `Organization/${orgId}`,
            type: "Organization",
            display: orgName,
        };
    }
    if (practitionerId) payload.practitionerId = practitionerId;
    if (requestedPeriod) payload.requestedPeriod = requestedPeriod;
    if (intakeQuestions) payload.intakeQuestions = intakeQuestions;
    if (proceedWith) payload.proceedWith = proceedWith;
    if (status) payload.status = status;
    if (patientLocation) payload.patientLocation = patientLocation;
    if (statusHistory) payload.statusHistory = statusHistory;
    if (actor) payload.actor = actor;
    if (encounterClass) payload.class = encounterClass;
    if (serviceLineId) payload.serviceLineId = serviceLineId;
    if (serviceLine) payload.serviceLine = serviceLine;

    return axios.put(`encounter/${encounterId}`, payload);
};

export const getActivePractitioners = (encounter, practitionerId = null) => {
    if (practitionerId) {
        return encounter?.participant?.filter(
            (participant) =>
                participant?.individual?.type === "Practitioner" &&
                participant?.period?.end === null &&
                participant?.individual?.reference === `Practitioner/${practitionerId}`
        ) || [];
    }

    return encounter?.participant?.filter(
        (participant) =>
            participant?.individual?.type === "Practitioner" &&
            participant?.period?.end === null
    ) || [];
};

export const editEncounterIntakeQuestions = ({ encounterId, payload }) => {
    payload.inPlaceUpdate = true;
    return axios.put(`encounter/${encounterId}`, payload);
};

export const addAddendumToEncounter = ({ encounterId, addenda }) =>
    axios.put(`encounter/${encounterId}`, { note: addenda });

export const triggerReportDelivery = ({ encounterId }) =>
    axios.post(`/report-delivery/trigger?encounterId=${encounterId}`);

export const getEncounterRecord = ({ encounterId }) =>
    axios.get(`encounter/${encounterId}`);

export const getQueueRecord = ({ encounterId, userOrganizationId }) =>
    axios.get(`queue/${encounterId}?orgId=${userOrganizationId}`);

export const getEncounterQuestionnaireResponses = ({ encounterId }) =>
    axios.get(`/questionnaireresponse?encounterId=${encounterId}`);

export const getPractitionerDataForQueue = ({ practitionerId }) =>
    axios.get(`/practitioner/${practitionerId}`);
